var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';
 let { leadSubmitted, photos, property, adsData, isPreload, virtualTourUrl, mapTemplate, isPhone, isTablet, isThumnails, mobileGallery, newLabel, isLeadFormSuppressed, pageType, propertyStatus, ab_mobile_pg_leads, supads, ab_midgallery_cta, ctaText, ctaButtonName} = options; 
__p+='\n';
 let loadedImageCount = isPhone ? 1 : 2 
__p+='\n';
 let thank_you_lead_text = "local real estate professionals" 
__p+='\n';
 let planName = '', communityName = '' 
__p+='\n';
 let tag = '' , tags = ''; 
__p+='\n\n';

  let heroImgSize;
  if (MOVE_DATA.isHdpiImage){
    heroImgSize = isPhone ? 'od-w480_h360': 'od-w1024_h768'
    if (window && window.devicePixelRatio > 1) {
      heroImgSize += '_x2';
    }
  } else {
    heroImgSize = isPhone ? 'xd-w480_h480_q80': 'xd-w1020_h770_q80';
  }

__p+='\n\n';
 let isNewPlan = false; 
__p+='\n';
 if (property && property.property_type === 'new_plan') { 
__p+='\n  ';
 isNewPlan = true 
__p+='\n  ';
 planName = property.name 
__p+='\n  ';
 communityName = property.community_name || (property.new_community || {}).name 
__p+='\n';
 } 
__p+='\n\n';
 if (isPreload){ 
__p+='\n  <!-- SHOW SOMETHING BEFORE CAROUSEL IS ENABLED -->\n  <div class="component_photo-fallback">\n    <div class="fallback-gallery">\n      ';
 if(photos.length && photos[0].url) { 
__p+='\n          <link href="'+
((__t=( photos[0].url.replace('xd-w480_h480_q80', heroImgSize) ))==null?'':__t)+
'" rel=\'preload\' as=\'image\'>\n          <div class="fallback-photo">\n           <img src="'+
((__t=( photos[0].url ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n          </div>\n          <div class="fallback-photo second-fallback-photo">\n           <img src="'+
((__t=( photos[0].url ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n          </div>\n      ';
 } else { 
__p+='\n        <div class="fallback-photo fallback-photo-empty">\n        </div>\n      ';
 } 
__p+='\n    </div>\n    <div class="photo-overlay-loading">\n    </div>\n  </div>\n';
 } else { 
__p+='\n  <div class="component_photo-gallery" id="js-qv-photo-section">\n    ';
 if (photos.length){ 
__p+='\n      <link href="'+
((__t=( photos[0].url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" rel=\'preload\' as=\'image\'>\n      ';
 if (!isPhone && photos.length > 1) { 
__p+='\n        <link href="'+
((__t=( photos[1].url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" rel=\'preload\' as=\'image\'>\n      ';
 } 
__p+='\n\n      <div class="rdc-carousel" id="js-qv-main-carousel">\n        <div class="owl-carousel">\n            ';
 photos.map(function(photo, index){ 
__p+='\n              <div class="photo-item">\n                ';
 if (index < loadedImageCount) {
__p+='\n                  <img data-index="'+
((__t=( index ))==null?'':__t)+
'" src="'+
((__t=( photo.url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" title="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" data-atf="'+
((__t=( index == 0))==null?'':__t)+
'">\n                ';
 } else{ 
__p+='\n                  <img data-index="'+
((__t=( index ))==null?'':__t)+
'" class="owl-lazy" data-src="'+
((__t=( photo.url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" title="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n                ';
 } 
__p+='\n              </div>\n            ';
 }) 
__p+='\n\n           \n            ';
 if (property.display_request_more_details_form && property.has_suppress_lead_form) { 
__p+='\n              <div class="photo-item photo-placeholder-item">\n                <img data-index="'+
((__t=( photos.length - 1 ))==null?'':__t)+
'" class="owl-lazy" src="'+
((__t=( photos[0].url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n                <div class="photo-media-bg">\n                  <div class="photo-media-cta">\n                    ';
 if (leadSubmitted) { 
__p+='\n                      <p>Thank you for your interest! Your message was sent to '+
((__t=( thank_you_lead_text ))==null?'':__t)+
'.</p>\n                    ';
 } else { 
__p+='\n                    <p class="js-leadtext-notsubmitted">Loving what you see? Find out more about this property.</p>\n                    <p class="js-leadtext-submitted hide">Thank you for your interest! Your message was sent to '+
((__t=(thank_you_lead_text ))==null?'':__t)+
'.</p>\n                    <a href="javascript:void(0);" class="btn btn-primary js-qv-contact-agent" data-omtag="ldp:quickview:carousel-cta:contact-agent" sticky-contact-agent mobile-carousel-cta>\n                        <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">\n                            '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n                          </span></div>\n                    </a>\n                    ';
 } 
__p+='\n                  </div>\n                </div>\n              </div>\n            ';
 } 
__p+='\n\n\n            ';
 if(adsData.show_photo_mrect) { 
__p+='\n              <div class="photo-item photo-ad-item">\n                <img data-index="'+
((__t=( photos.length - 1 ))==null?'':__t)+
'" class="owl-lazy" src="'+
((__t=( photos[0].url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n                <div class="photo-media-bg"></div>\n              </div>\n            ';
 } 
__p+='\n        </div>\n\n        ';
 if (ab_midgallery_cta && !isLeadFormSuppressed && !leadSubmitted && !isPhone) { 
__p+='\n          <div class="no-show ab-midgallery-cta" id="ab-midgallery-cta">\n            <span class="font-bold font-size-base padding-right-lg">Loving what you see? </span>\n            <a href="javacript:void(0)" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':photogallery:mid_lead_cta" class="js-qv-contact-agent btn btn-primary round-cta">\n              '+
((__t=( ctaButtonName ))==null?'':__t)+
'\n            </a>\n          </div>\n        ';
 } 
__p+='\n\n        ';
 if(adsData.show_photo_mrect) { 
__p+='\n          <div class="qv-photo-ad hide" id="quickview-photo-mrect">\n            <div class="ads mrect qv-photo-ad-content">\n              <div id="div-gpt-ad-PHOTOMRECT1" class="photomrect-ad"></div>\n              ';
 if(!isPhone) { 
__p+='\n                <div id="div-gpt-ad-PHOTOMRECT2V" class="photomrect-ad-full"></div>\n              ';
 } 
__p+='\n            </div>\n            ';
 if(isPhone) { 
__p+='\n              ';
 if (supads && !supads.toUpperCase().split(',').includes('ALL') && !supads.toUpperCase().split(',').includes('PHOTOMRECT1')) { 
__p+='\n                <button type="button" id="photomrect1-ad-close" class="mobile-galleryad-close close-carousel" aria-label="Close">\n                  <span aria-hidden="true"><i class="ra ra-close-thin"></i></span>\n                </button>\n              ';
 } 
__p+='\n              <button type="button" id="photomrect2-ad-close" class="mobile-galleryad-close close-gallery" aria-label="Close">\n                <span aria-hidden="true"><i class="ra ra-close-thin"></i></span>\n              </button>\n            ';
 } 
__p+='\n          </div>\n        ';
 } 
__p+='\n\n        ';
 if (property.display_request_more_details_form) { 
__p+='\n        <div class="qv-sec-gallery-lead-form">\n          <div class="fwt-text hidden-qv-xs hidden-qv-sm">\n            <div class="fwt-text-wrapper">\n              <div class="fwt-text-title">Your Perfect Home</div>\n              <ul class="fwt-text-content list-unstyled">\n                <li><i class="ra ra-check-mark"></i>Get all the answers</li>\n                <li><i class="ra ra-check-mark"></i>Talk to a local expert</li>\n                <li><i class="ra ra-check-mark"></i>No Commitment. 100% Free</li>\n              </ul>\n            </div>\n          </div>\n          <div class="lead-form-outer-wrapper">\n            <div class="lead-form-inner-wrapper">\n              <div id="aj-qv-sec-gallery-leadform"></div>\n            </div>\n          </div>\n        </div>\n        ';
 } 
__p+='\n\n        ';
 if(!isPhone) { 
__p+='\n        <div class="rdc-carousel-nav photo-carousel-nav">\n          <div class="rdc-prev-set photo-prev" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':edw:photo_prev"><i class="ra ra-angle-left"></i></div>\n          <div class="rdc-next-set photo-next" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':edw:photo_next"><i class="ra ra-angle-right"></i></div>\n        </div>\n        ';
 } 
__p+='\n\n      </div>\n\n      ';
 if (isThumnails) { 
__p+='\n        <div class="thumbnails-carousel hide-left-nav hide-right-nav" id="js-qv-thumbnails-carousel">\n          <div class="owl-carousel">\n            ';
 if(photos) { 
__p+='\n              ';
 photos.map(function(photo,index){ 
__p+='\n                <div class="photo-thumbnail-item" data-index='+
((__t=( index ))==null?'':__t)+
'>\n                  <img data-photo-src="'+
((__t=( photo.url.replace('xd-w640_h480_q80', 'xd-w140_h105_q80') ))==null?'':__t)+
'" alt="">\n                </div>\n              ';
 }) 
__p+='\n            ';
 } 
__p+='\n          </div>\n          <div class="thumbnails-photo-count">\n            ';
 if (photos.length > 1){ 
__p+='\n              <span class="active-photo-index">1</span><span> / '+
((__t=( photos.length ))==null?'':__t)+
'</span>\n            ';
 }else{  
__p+='\n              <span class="active-photo-index">1</span> <span class="hidden-xxs hidden-xs hidden-sm">Photo</span>\n            ';
 } 
__p+='\n          </div>\n          <div class="rdc-carousel-nav">\n            <div class="rdc-prev-set hide"><i class="ra ra-angle-left"></i></div>\n            <div class="rdc-next-set hide"><i class="ra ra-angle-right"></i></div>\n          </div>\n        </div>\n      ';
 } 
__p+='\n\n      ';
 if (mobileGallery) { 
__p+='\n        <div class="qv-mobile-carousel" id="js-qv-mobile-carousel">\n            <div class="owl-carousel">\n              ';
 photos.map(function(photo, index){ 
__p+='\n                ';
 if (photo.tags && photo.tags.length > 0) { 
                  if (Array.isArray(photo.tags) && photo.tags.others) { 
                    tag = 'others'; 
                  } else if (photo.tags[0].label) { 
                    tag = photo.tags[0].label; 
                  } 
                  tags = (tag && ('photo-label-' + tag) || '') + ' photo-label-all' 
                } 
__p+='\n                <div class="photo-item-mobile" id="photo'+
((__t=( index ))==null?'':__t)+
'">\n                  ';
 if (index < 2) {
__p+='\n                    <img class="photo-label-all '+
((__t=( tags ))==null?'':__t)+
'" data-index="'+
((__t=( index ))==null?'':__t)+
'" src="'+
((__t=( photo.url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" title="'+
((__t=( property.full_address_display ))==null?'':__t)+
'">\n                  ';
 } else { 
__p+='\n                    <img class="photo-label-all '+
((__t=( tags ))==null?'':__t)+
'" data-index="'+
((__t=( index ))==null?'':__t)+
'" data-src="'+
((__t=( photo.url.replace('xd-w640_h480_q80', heroImgSize) ))==null?'':__t)+
'" alt="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" title="'+
((__t=( property.full_address_display ))==null?'':__t)+
'" class="owl-lazy">\n                  ';
 } 
__p+='\n                  ';
 if (!isLeadFormSuppressed && index === 4 && photos.length > 6 && property.has_suppress_lead_form){ 
__p+='\n                    <div class="list-gallery-lead-btn">\n                      ';
 if (!isNewPlan) { 
__p+='\n                        <span class="ab-email-section-photo-text">Love this home?</span>\n                        <a href="javascript:void(0);" class="js-hide-ajax-fail round-cta ';
 if (leadSubmitted) { 
__p+='contacted';
 } else { 
__p+='js-qv-contact-agent';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+='data-omtag="ldp:quickview:between-photos:contact-agent" data-formid="secondary"';
 } 
__p+=' sticky-contact-agent>\n                          <div class="icon-email-container"><span class="email-icon"></span><span class="ab-email-text-form">'+
((__t=( ctaButtonName ))==null?'':__t)+
'</span></div>\n                        </a>\n                      ';
 } else { 
__p+='\n                        <span>Love this home?</span>\n                        <a href="javascript:void(0);" class="js-hide-ajax-fail round-cta ';
 if (leadSubmitted) { 
__p+='contacted';
 } else { 
__p+='js-qv-contact-agent';
 } 
__p+='" ';
 if (!leadSubmitted) { 
__p+='data-omtag="ldp:quickview:between-photos:contact-agent" data-formid="secondary"';
 } 
__p+=' sticky-contact-agent>';
 if (leadSubmitted) { 
__p+='Contacted';
 } else { 
__p+=''+
((__t=( ctaButtonName ))==null?'':__t)+
'';
 } 
__p+='\n                        </a>\n                      ';
 } 
__p+='\n                    </div>\n                  ';
 } 
__p+='\n                </div>\n              ';
 }) 
__p+='\n            </div>\n\n          ';
 if(ab_mobile_pg_leads == "V1" || ab_mobile_pg_leads == "V2") {
__p+='\n            ';
 if(property.display_request_more_details_form && photos.length > 1) { 
__p+='\n              <div class="list-gallery-leadform padding-bottom">\n                <div class="lead-form-outer-wrapper">\n                  <div class="lead-form-inner-wrapper">\n                    <div id="aj-qv-sec-gallery-leadform-mobile-fullscreen"></div>\n                  </div>\n                </div>\n              </div>\n            ';
 } 
__p+='\n          ';
 } 
__p+='\n\n          <div class="qv-mobile-gallery-full-ad">\n            <div id="div-gpt-ad-PHOTOMRECT2V" class="photomrect-ad-full"></div>\n          </div>\n\n          ';
 if(!(ab_mobile_pg_leads == "V1" || ab_mobile_pg_leads == "V2")) {
__p+='\n            ';
 if(property.display_request_more_details_form && photos.length > 1) { 
__p+='\n              <div class="list-gallery-leadform">\n                <div class="lead-form-outer-wrapper">\n                  <div class="lead-form-inner-wrapper">\n                    <div id="aj-qv-sec-gallery-leadform-mobile-fullscreen"></div>\n                  </div>\n                </div>\n              </div>\n            ';
 } 
__p+='\n          ';
 } 
__p+='\n\n          <div id="qv-mobile-fullcarousel-counter" class="qv-mobile-fullcarousel-counter"></div>\n        </div>\n      ';
 } 
__p+='\n    ';
 } 
__p+='\n\n    '+
((__t=( mapTemplate(options) ))==null?'':__t)+
'\n  </div>\n   \n  <!-- LABELS AND PHOTO COUNT -->\n  <div class="component_photo-overlay '+
((__t=( photos.length ? '' : 'offset-bottom' ))==null?'':__t)+
'">\n    <div class="property-status">\n      ';
 if (property.flags.is_pending) { 
__p+='\n        <div class="display-inline-block label label-red label-pending margin-right-sm"><span id="label-pending">Pending</span></div>\n      ';
 } else if (property.flags.is_contingent) { 
__p+='\n        <div class="display-inline-block label label-red margin-right-sm"><span id="label-contingent">Contingent</span></div>\n      ';
 } else if (property.flags.is_new_listing) {
__p+='\n        <div class="display-inline-block label label-green label-new margin-right-sm"><span id="label-new">'+
((__t=( newLabel ))==null?'':__t)+
'</span></div>\n      ';
 } else if (property.property_type === "recently_sold") {
__p+='\n        <div class="display-inline-block label label-gray-darker label-sold margin-right-sm"><span id="label-sold">Just sold</span></div>\n      ';
 } 
__p+='\n      ';
 if (property.flags.is_price_reduced && MOVE_DATA.ab_hlt_price_drop === "V1") { 
__p+='\n        <div class="display-inline-block label label-dark-green margin-right-sm"><span id="label-contingent">Price Reduced</span></div>\n      ';
 } 
__p+='\n\n      ';
 if ($('body').hasClass('desktop-full-qv')){ 
__p+='\n        <span class="display-inline-block label label-dark-transparent label-outline-none margin-right-sm">\n          '+
((__t=( property.status_display_below_hero_image ))==null?'':__t)+
'\n          ';
 if (property.property_type === 'for_sale' &&
                  !property.flags.is_pending &&
                  !property.flags.is_contingent &&
                  property.property_status_display &&
                  property.property_type != "new_plan" &&
                  property.property_status_display != "For Sale") { 
__p+='\n          <span>\n            <span class="padding-left-sm padding-right-sm"> - </span>\n            <span data-label="property-meta-active">'+
((__t=( property.property_status_display ))==null?'':__t)+
'</span>\n          </span>\n          ';
 } 
__p+='\n        </span>\n      ';
 } 
__p+='\n\n      ';
 if(property.open_houses) { 
__p+='\n          <span class="label label-dark-transparent label-outline-none"> Open <span class="hidden-xxs hidden-xs">House</span> '+
((__t=( property.open_houses[0].short_date_display ))==null?'':__t)+
'</span>\n      ';
 } 
__p+='\n\n      ';
 if (property.flags.is_foreclosure){ 
__p+='\n        <div class="display-inline-block label label-gray-transparent margin-right-sm">\n          <span data-label="property-meta-foreclosure">Foreclosure</span>\n        </div>\n      ';
 } 
__p+='\n\n      ';
 if (property.flags.is_short_sale){ 
__p+='\n        <div class="display-inline-block label label-gray-transparent margin-right-sm">\n          <span data-label="property-meta-shortsale">Short Sale</span>\n        </div>\n      ';
 } 
__p+='\n\n      ';
 if (property.sold_date){ 
__p+='\n        <span class="font-size-base font-normal font-size-small hidden-qv-md" data-label="property-meta-sold-date">Sold on '+
((__t=( property.sold_date ))==null?'':__t)+
'</span>\n      ';
 } 
__p+='\n    </div>\n\n    ';
 if (property.matterport_url && !(isPhone || isTablet)){ 
__p+='\n      <div class="matterport-label">\n        <a data-toggle="modal" data-target="#fs-matterport-modal" data-omtag="ldp:photogallery:3d-view">\n          <div class="label label-dark-transparent label-outline-none margin-right-sm">\n            <i class="icon-3d-view"></i> 3D View\n          </div>\n        </a>\n      </div>\n    ';
 } 
__p+='\n\n    ';
 if (property.flags.has_tour){ 
__p+='\n      <div class="float-right margin-right-sm vr-tour-btn hidden-xxs">\n        <a href="'+
((__t=( virtualTourUrl ))==null?'':__t)+
'" target="_blank" id="hero-view-tour" data-omtag="ldp:photogallery:virtual-tour">\n          <div class="label label-dark-transparent label-outline-none">\n            <i class="ra ra-share-square"></i> VR Tour\n          </div>\n        </a>\n      </div>\n    ';
 } 
__p+='\n\n    ';
 if (!property.flags.is_suppress_map){ 
__p+='\n      ';
 if (photos && photos.length && !photos[0].url.includes('https://maps.googleapis.com/maps/api/streetview')){ 
__p+='\n        <div class="carousel-photo-count float-right">\n          <div class="label label-dark-transparent label-outline-none" data-omtag="ldp:photogallery:photos">\n            <i class="ra ra-camera icon-space-right-sm"></i>\n            ';
 if (photos.length > 1){ 
__p+='\n              <span class="active-photo-index">1</span><span> / '+
((__t=( photos.length ))==null?'':__t)+
'</span>\n            ';
 }else{  
__p+='\n              <span class="active-photo-index">1</span> <span class="hidden-xxs hidden-xs hidden-sm">Photo</span>\n            ';
 } 
__p+='\n          </div>\n        </div>\n      ';
 } 
__p+='\n    ';
 } 
__p+='\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/qv-sec-photo.jst.ejs